/* Baminger First-Party Behavior Tracker — bam-track.js
 *
 * ZIEL: anonymes, DSGVO-konformes Verhaltens-Tracking, das die Website NIE crasht
 * und automatisch mit Änderungen mitwächst.
 *
 * MODULARITÄT (nicht aufweichen):
 *   - EIN delegierter document-Listener statt fester CSS-Selektoren. Neue Buttons/
 *     Sections werden automatisch erfasst (Heuristik) oder gezielt via [data-track].
 *   - Dynamisch nachgeladenes DOM (Konfigurator) ist durch Event-Delegation gratis abgedeckt.
 *   - ALLES in try/catch. Fällt der Tracker → Seite läuft weiter. Ist der Server down →
 *     Events werden still verworfen, kein Fehler für den Besucher.
 *
 * CONSENT (an bam_cookie_consent im localStorage gekoppelt — selber Schlüssel wie Banner):
 *   - "yes"  → Voll-Modus: persistente Session-ID (Funnel-Stitching im Besuch) + Microsoft Clarity.
 *   - sonst  → Anonym-Modus: KEINE persistente Session-ID (nur aggregierte Zählung), kein Clarity.
 *
 * Konfigurator/Custom-Hooks: einfach window.bamTrack('event_name', {key:val}) aufrufen.
 */
(function () {
  "use strict";
  try {
    var CFG = window.__BAM_TRACK__ || {};

    // EIGENE TESTS ZÄHLEN NICHT (01.10.2026): Automatisierte Browser (Playwright & Co. setzen
    // navigator.webdriver) und Geräte, die einmal ?bam_test=1 aufgerufen haben, senden nichts
    // und laden kein Clarity. ?bam_test=0 hebt die Markierung im Browser wieder auf.
    // Grund: Testläufe am 08./09./18.09.2026 haben die Q3-Auswertung verfälscht.
    var TEST = (function () {
      try {
        var t = new URLSearchParams(location.search).get("bam_test");
        if (t === "1") localStorage.setItem("bam_test", "1");
        if (t === "0") localStorage.removeItem("bam_test");
        return navigator.webdriver === true || localStorage.getItem("bam_test") === "1";
      } catch (e) { return !!(window.navigator && navigator.webdriver); }
    })();
    if (TEST) {
      window.bamTrack = function () { };
      window.bamTrackEnableFull = function () { };
      return;
    }

    var ENDPOINT = CFG.endpoint || "https://api.lkw-baminger.at/api/track";
    var QUEUE = [];
    var flushTimer = null;
    var FLUSH_MS = 4000;

    function consent() { try { return localStorage.getItem("bam_cookie_consent"); } catch (e) { return null; } }
    // Analyse-Consent: neues JSON-Objekt {analytics,marketing} ODER alter String "yes"/"no" (abwärtskompat).
    function fullConsent() {
        try {
            var raw = localStorage.getItem("bam_cookie_consent");
            if (!raw) return false;
            if (raw === "yes") return true;
            if (raw === "no") return false;
            return !!JSON.parse(raw).analytics;
        } catch (e) { return false; }
    }
    function rnd() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }

    // Session-ID nur bei voller Zustimmung persistent (Stitching im Besuch).
    // Ohne Zustimmung: null → serverseitig keine Journey-Verkettung = echt anonym.
    function sessionId() {
      try {
        if (!fullConsent()) return null;
        var s = sessionStorage.getItem("bam_track_sid");
        if (!s) { s = rnd(); sessionStorage.setItem("bam_track_sid", s); }
        return s;
      } catch (e) { return null; }
    }

    // Besucher-ID (localStorage) NUR mit Consent → erlaubt „neu vs. wiederkehrend".
    // Gibt {visitor, returning}. Ohne Consent: kein persistenter Identifier.
    var _newThisLoad = false;
    function visitorInfo() {
      try {
        if (!fullConsent()) return { visitor: null, returning: null };
        var v = localStorage.getItem("bam_track_vid");
        var returning = !!v;
        if (!v) { v = rnd(); localStorage.setItem("bam_track_vid", v); _newThisLoad = true; }
        return { visitor: v, returning: returning ? 1 : 0 };
      } catch (e) { return { visitor: null, returning: null }; }
    }

    function referrerHost() {
      try {
        if (!document.referrer) return undefined;
        var h = new URL(document.referrer).host;
        // Seitenwechsel innerhalb der Website als „(intern)“ markieren — sonst landete jeder
        // zweite Aufruf als „direct“ in der Kanal-Auswertung (Q3 2026: 84 % „Direkt“).
        if (!h || h === location.host) return "(intern)";
        return h.slice(0, 120);
      } catch (e) { return undefined; }
    }

    function txt(el) { try { return (el.textContent || "").trim().replace(/\s+/g, " ").slice(0, 80); } catch (e) { return ""; } }

    function ctx() {
      var u = {};
      try {
        var q = new URLSearchParams(location.search);
        ["utm_source", "utm_medium", "utm_campaign"].forEach(function (k) { var v = q.get(k); if (v) u[k] = v.slice(0, 120); });
        // Google-Ads-Klicks tragen nur gclid/gbraid/wbraid (Auto-Tagging), keine UTM → sonst nicht
        // von der normalen Google-Suche zu unterscheiden.
        if (!u.utm_source && (q.get("gclid") || q.get("gbraid") || q.get("wbraid"))) { u.utm_source = "google"; u.utm_medium = "cpc"; }
      } catch (e) { }
      var b2b = !!(window.__BAMINGER_IS_B2B__ || CFG.isB2B);
      var o = {
        path: location.pathname.slice(0, 200),
        lang: ((document.documentElement.lang || CFG.lang || "")).slice(0, 8),
        market: (CFG.market || "").slice(0, 8),
        is_b2b: b2b,
        consent: fullConsent() ? 1 : 0,
        session: sessionId(),
        utm_source: u.utm_source, utm_medium: u.utm_medium, utm_campaign: u.utm_campaign
      };
      // Eingeloggte HÄNDLER mit Analyse-Zustimmung: Kundenkonto + Firma mitschicken → Händler-
      // Nachfassliste im Quartalsbericht (Philipp 01.10.2026). Datenschutzerklärung Abschnitt 20
      // „Eingeloggte B2B-Kunden“. Privatkunden NIE, Händler ohne Zustimmung auch nicht.
      if (b2b && CFG.customer && o.consent) {
        o.customer = String(CFG.customer).slice(0, 40);
        o.company = String(CFG.company || "").slice(0, 120);
      }
      return o;
    }

    function track(event, data) {
      try {
        if (!event) return;
        var c = ctx();
        var ev = { event: String(event).slice(0, 80) };
        for (var k in c) { if (c[k] !== undefined && c[k] !== null && c[k] !== "") ev[k] = c[k]; }
        if (data && typeof data === "object") { for (var d in data) { if (data[d] !== undefined && data[d] !== null) ev[d] = data[d]; } }
        QUEUE.push(ev);
        if (QUEUE.length >= 20) flush(); else schedule();
      } catch (e) { }
    }
    window.bamTrack = track; // öffentlicher Hook für Konfigurator & co.

    function schedule() { if (!flushTimer) flushTimer = setTimeout(flush, FLUSH_MS); }
    function flush() {
      flushTimer = null;
      if (!QUEUE.length) return;
      var batch = QUEUE.splice(0, 40);
      var body = JSON.stringify({ events: batch });
      try {
        // WICHTIG: text/plain (CORS-safelisted) → kein Preflight → Beacon kommt an.
        // application/json würde einen Preflight auslösen, den sendBeacon nicht kann → still verworfen.
        // Der Server parst den Body ohnehin als JSON, unabhängig vom Content-Type.
        if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "text/plain" }))) return;
      } catch (e) { }
      try {
        fetch(ENDPOINT, { method: "POST", body: body, headers: { "Content-Type": "application/json" }, keepalive: true, mode: "cors" }).catch(function () { });
      } catch (e) { }
    }
    document.addEventListener("visibilitychange", function () { if (document.visibilityState === "hidden") flush(); });
    window.addEventListener("pagehide", flush);

    // ── Auto-Instrumentierung ─────────────────────────────────────────────────
    function ready(fn) { if (document.readyState !== "loading") fn(); else document.addEventListener("DOMContentLoaded", fn); }

    function autobind() {
      // Delegierter Klick-Capture: [data-track] gewinnt, sonst Heuristik für Links/Buttons.
      document.addEventListener("click", function (e) {
        try {
          var explicit = e.target.closest("[data-track]");
          if (explicit) { track("click", { label: (explicit.getAttribute("data-track") || "").slice(0, 120), text: txt(explicit) }); return; }
          var el = e.target.closest("a,button,[role=button],input[type=submit]");
          if (!el) return;
          var href = el.getAttribute && el.getAttribute("href");
          var kind = "click";
          if (href) {
            if (/^tel:/i.test(href)) kind = "phone_click";
            else if (/wa\.me|whatsapp/i.test(href)) kind = "whatsapp_click";
            else if (/^mailto:/i.test(href)) kind = "mail_click";
            else if (/calendly/i.test(href)) kind = "calendly_click";
            else if (/^https?:/i.test(href) && href.indexOf(location.host) === -1) kind = "outbound_click";
          }
          track(kind, {
            text: txt(el), tag: el.tagName.toLowerCase(),
            href: href ? href.slice(0, 200) : undefined,
            eid: el.id || undefined,
            cls: (el.className && typeof el.className === "string") ? el.className.slice(0, 80) : undefined
          });
        } catch (err) { }
      }, true);

      // Section-Sichtbarkeit nur für explizit annotierte [data-track-view] → kein Spam.
      try {
        if ("IntersectionObserver" in window) {
          var seen = {};
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (!en.isIntersecting) return;
              var name = en.target.getAttribute("data-track-view") || en.target.id;
              if (name && !seen[name]) { seen[name] = 1; track("section_view", { section: name.slice(0, 80) }); }
            });
          }, { threshold: 0.4 });
          document.querySelectorAll("[data-track-view]").forEach(function (s) { io.observe(s); });
        }
      } catch (e) { }

      // Scrolltiefe 25/50/75/100 — je 1x pro Seite.
      try {
        var marks = { 25: 0, 50: 0, 75: 0, 100: 0 };
        window.addEventListener("scroll", function () {
          var h = document.documentElement;
          var pct = (h.scrollTop) / ((h.scrollHeight - h.clientHeight) || 1) * 100;
          [25, 50, 75, 100].forEach(function (m) { if (!marks[m] && pct >= m) { marks[m] = 1; track("scroll_depth", { depth: m }); } });
        }, { passive: true });
      } catch (e) { }
    }

    ready(function () {
      var vi = visitorInfo();
      track("pageview", { referrer: referrerHost(), visitor: vi.visitor, returning: vi.returning });
      autobind();
    });

    // ── Voll-Consent-Extras: Microsoft Clarity (Heatmaps/Replay) ──────────────
    function bootClarity() {
      try {
        var id = CFG.clarityId;
        if (!id || window.clarity) return;
        (function (c, l, a, r, i, t, y) {
          c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
          t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
          y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", id);
      } catch (e) { }
    }
    // Vom Cookie-Banner bei „Akzeptieren" gerufen:
    window.bamTrackEnableFull = function () { try { track("consent_granted"); bootClarity(); } catch (e) { } };
    if (fullConsent()) bootClarity();
  } catch (e) { /* Tracker darf die Seite nie crashen */ }
})();
